import type { NextPage } from 'next'
import { Col, Container, Link, Row } from 'atoms'
import { Layout, Main } from 'layout'
import Head from 'next/head'

const Home: NextPage = () => (
  <Layout>
    <Head>
      <title>Imprint | anhil-fashion.de</title>
      <meta name="description" content="Impressum anhil.fashion" />
    </Head>
    <Main>
      <Container>
        <Row>
          <Col>
            <h1 className="text-secondary">
              Impressum
            </h1>
            <p>
              anhil.fashion
              <br/>
              Anna-Maria Hillig
              <br/>
              Zeppelinstr. 12
              <br/>
              12459 Berlin
            </p>
            <Link href="/">
              Home
            </Link>
          </Col>
        </Row>
      </Container>
    </Main>
  </Layout>
)

export default Home
